import { render, staticRenderFns } from "./FriendRequestIcon.vue?vue&type=template&id=b5664e86&scoped=true"
import script from "./FriendRequestIcon.vue?vue&type=script&lang=js"
export * from "./FriendRequestIcon.vue?vue&type=script&lang=js"
import style0 from "./FriendRequestIcon.vue?vue&type=style&index=0&id=b5664e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5664e86",
  null
  
)

export default component.exports